import { render } from "./PageKategoriler.vue?vue&type=template&id=249f25f1"
import script from "./PageKategoriler.vue?vue&type=script&lang=js"
export * from "./PageKategoriler.vue?vue&type=script&lang=js"
script.render = render

export default script